import { SelectWithAll } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Form, SelectProps } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext, useMemo } from "react";
import { getPriorityProps } from "../../../../../tickets";
import { PathContext } from "../../../context/PathContext";
import { FormItemPath } from "../../../types/Config";

type Props = {};

export const PriorityFieldSelect = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);
  const { thresholds, getPriorityLabelByValue } = getPriorityProps();

  const options: SelectProps["options"] = useMemo(
    () =>
      thresholds.map((threshold) => ({
        label: t(getPriorityLabelByValue(threshold)),
        value: threshold,
      })),
    []
  );

  return (
    <Form.Item<FormItemPath<"priority">>
      name={[...path, "priority"]}
      label={t("maintenance:ticket.create.config.priority.priority.label")}
      initialValue={thresholds}
    >
      <SelectWithAll
        allLabel={t("maintenance:general.all")}
        options={options}
      />
    </Form.Item>
  );
});
